import type { Graph, GraphModification } from "@lr-notitia/notitia-operator/schemas";
import type { DescriptorNotification } from "@lr-notitia/notitia-model-store/schemas";
import { UserRole } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed, ref } from "vue";
import { useDomainStore } from "../domain";
import { useInstanceWorkspacesStore } from "../i-workspace";
import { api } from "@lr-notitia/notitia-operator/client";
import { handleGraphModification } from "./utils";

let domainStore: ReturnType<typeof useDomainStore>;
let instanceWorkspacesStore: ReturnType<typeof useInstanceWorkspacesStore>;
function init() {
	domainStore = useDomainStore();
	instanceWorkspacesStore = useInstanceWorkspacesStore();
}

export const hiddenNotifications = ref<string[]>([]);

export const notifications = (graph: Ref<Graph>) =>
	computed<DescriptorNotification[]>(() => {
		return Object.values(graph.value.nodes).filter(
			(node) =>
				node.layer === "descriptor" &&
				node.type === "notification" &&
				!hiddenNotifications.value.includes(node.id)
		) as DescriptorNotification[];
	});
export function notification(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
		remove: (id: string) => remove(domainId, graph, id),
	};
}

function byId(id: string, graph: Ref<Graph>): DescriptorNotification | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "notification" && hit.layer === "descriptor"
		? (hit as DescriptorNotification)
		: undefined;
}

function remove(domainId: Ref<string>, graph: Ref<Graph>, id: string): Promise<GraphModification> {
	if (!domainStore || !instanceWorkspacesStore) init();
	return new Promise((resolve, reject) => {
		if (!domainStore.hasAccessRights(UserRole.Editor)) return reject();
		if (!graph.value.nodes[id]) return reject();
		if (!instanceWorkspacesStore.openedWorkspaceId) return reject();
		api()
			.domain(domainId.value)
			.workspace(instanceWorkspacesStore.openedWorkspaceId)
			.notification(id)
			.del()
			.then((data) => {
				hiddenNotifications.value.push(id);
				handleGraphModification(data.modification, data.metadata);
				resolve(data.modification);
			})
			.catch(() => reject());
	});
}
